"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapProperty = void 0;
/**
 * Takes an array of objects and returns an array of values from the given `property`
 *
 * @param array The array of objects
 * @param property The property to extract
 */
exports.mapProperty = (array, property) => {
    return array.map((element) => element[property]);
};
//# sourceMappingURL=map-property.js.map